
import { Link } from 'react-router-dom';

export default function Fleet() {
  const fleetCategories = [
    {
      title: "Executive Economy",
      subtitle: "EFFICIENCY REDEFINED",
      description: "Precision-engineered vehicles combining fuel efficiency with contemporary comfort for the modern professional.",
      image: "https://public.readdy.ai/ai/img_res/81e1da3fac1a14ba60dd559dea7d074e.jpg",
      features: ["Advanced fuel management", "City optimization technology", "Premium interior appointments", "Connected mobility suite"],
      price: "From $39",
      period: "/day",
      badge: "MOST POPULAR"
    },
    {
      title: "Business Class Sedans",
      subtitle: "EXECUTIVE EXCELLENCE",
      description: "Distinguished vehicles crafted for executive travel, featuring advanced comfort technologies and premium appointments.",
      image: "https://readdy.ai/api/search-image?query=Premium%20executive%20sedan%20in%20sophisticated%20showroom%20environment%2C%20luxury%20business%20vehicle%20with%20leather%20interior%2C%20professional%20automotive%20setting%20with%20elegant%20lighting%2C%20high-end%20comfortable%20car%20for%20corporate%20executives&width=500&height=350&seq=fleet-exec2&orientation=landscape",
      features: ["Executive comfort systems", "Advanced connectivity", "Professional presentation", "Long-distance optimization"],
      price: "From $89",
      period: "/day",
      badge: "EXECUTIVE CHOICE"
    },
    {
      title: "Premium SUV Collection",
      subtitle: "VERSATILITY ELEVATED",
      description: "Commanding presence with uncompromising luxury. Designed for families and groups who demand excellence in every detail.",
      image: "https://readdy.ai/api/search-image?query=Luxury%20SUV%20crossover%20in%20upscale%20automotive%20showroom%2C%20premium%20family%20vehicle%20with%20sophisticated%20interior%2C%20elegant%20automotive%20display%20setting%20with%20marble%20floors%20and%20professional%20lighting&width=500&height=350&seq=fleet-exec3&orientation=landscape",
      features: ["Spacious luxury interiors", "All-terrain capability", "Advanced safety systems", "Premium cargo solutions"],
      price: "From $129",
      period: "/day",
      badge: "FAMILY LUXURY"
    },
    {
      title: "Commercial Solutions",
      subtitle: "ENTERPRISE GRADE",
      description: "Professional-grade vehicles engineered for commercial applications, delivering reliability and performance when it matters most.",
      image: "https://readdy.ai/api/search-image?query=Professional%20commercial%20van%20and%20truck%20fleet%20in%20modern%20corporate%20facility%2C%20enterprise-grade%20utility%20vehicles%20with%20clean%20industrial%20setting%2C%20business%20transportation%20solutions%20in%20sophisticated%20environment&width=500&height=350&seq=fleet-exec4&orientation=landscape",
      features: ["Commercial-grade durability", "Enhanced payload capacity", "Fleet management systems", "24/7 support included"],
      price: "From $149",
      period: "/day",
      badge: "ENTERPRISE"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-blue-50 border border-blue-100 rounded-full mb-8">
            <i className="ri-car-line text-blue-600 mr-2"></i>
            <span className="text-sm font-semibold text-blue-800 tracking-wide uppercase">Premium Fleet Collection</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 leading-tight">
            <span className="font-extralight">Curated</span> <span className="font-bold">Excellence</span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-light">
            Our meticulously maintained fleet represents the pinnacle of automotive excellence. Each vehicle undergoes 
            comprehensive inspection and premium detailing to ensure an exceptional experience that exceeds expectations.
          </p>
        </div>

        {/* Fleet Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
          {fleetCategories.map((category, index) => (
            <div key={index} className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-blue-200">
              {/* Image Container */}
              <div className="relative h-64 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-50">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                
                {/* Badge */}
                <div className="absolute top-6 left-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white px-4 py-2 rounded-full text-xs font-bold tracking-wide shadow-lg">
                  {category.badge}
                </div>
                
                {/* Price Tag */}
                <div className="absolute top-6 right-6 bg-white/95 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full shadow-lg">
                  <div className="text-right">
                    <div className="text-lg font-bold">{category.price}</div>
                    <div className="text-xs text-gray-600 font-medium">{category.period}</div>
                  </div>
                </div>

                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              {/* Content */}
              <div className="p-8">
                <div className="mb-6">
                  <div className="text-xs font-bold text-blue-600 tracking-widest uppercase mb-2">
                    {category.subtitle}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 leading-tight">{category.title}</h3>
                  <p className="text-gray-600 leading-relaxed font-light">{category.description}</p>
                </div>
                
                {/* Features */}
                <div className="space-y-3 mb-8">
                  {category.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-sm text-gray-700">
                      <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                        <i className="ri-check-line text-green-600 text-xs"></i>
                      </div>
                      <span className="font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
                
                {/* CTA Button */}
                <Link
                  to="/fleet"
                  className="block w-full bg-gradient-to-r from-gray-900 to-gray-800 hover:from-blue-600 hover:to-blue-800 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  <i className="ri-eye-line mr-2"></i>
                  View Collection
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-8 bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <div className="flex items-center text-gray-600">
              <i className="ri-phone-line text-blue-600 mr-3 text-xl"></i>
              <div>
                <div className="font-semibold text-gray-900">Concierge Service</div>
                <div className="text-sm">24/7 Personal Assistance</div>
              </div>
            </div>
            
            <div className="w-px h-12 bg-gray-200"></div>
            
            <div className="flex items-center text-gray-600">
              <i className="ri-shield-check-line text-green-600 mr-3 text-xl"></i>
              <div>
                <div className="font-semibold text-gray-900">Premium Insurance</div>
                <div className="text-sm">Comprehensive Coverage</div>
              </div>
            </div>
            
            <div className="w-px h-12 bg-gray-200"></div>
            
            <div className="flex items-center text-gray-600">
              <i className="ri-time-line text-blue-600 mr-3 text-xl"></i>
              <div>
                <div className="font-semibold text-gray-900">Instant Booking</div>
                <div className="text-sm">Immediate Confirmation</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
